import { t } from '@/features/i18n/utils';
import { createFileRoute, redirect } from '@tanstack/react-router';
import { getDefaultStore } from 'jotai';
import { bidComparisonSheetsQuery } from '@/features/bid-comparison/queries';
import { lastSelectedSheetIdAtom } from '@/features/bid-comparison/store';
import z from 'zod';
import { ArrowDataTransferHorizontalIcon } from '@hugeicons-pro/core-stroke-rounded';
import { Icon } from '@/ui/components/icon';
import { BreadcrumbPage } from '@/ui/components/breadcrumb';
import { Header, HeaderBackButton, HeaderChatButton } from '@/ui/components/header';
import { useProjectView } from '@/features/projects/helpers';
import { BidsBreadcrumbs } from '@/features/bids/components/bids-breadcrumbs';
import { BidComparisonSheetPage } from '@/features/bid-comparison/components/bid-comparison-sheet-page';

export const Route = createFileRoute(
  '/_authed/project/$projectId/workspaces/$workspaceId/bids/_layout/comparison/$sheetId',
)({
  component: RouteComponent,
  beforeLoad: async ({ context, params }) => {
    const sheets = await context.queryClient.query({
      ...bidComparisonSheetsQuery(params.workspaceId),
      staleTime: 'static',
    });
    if (!sheets.some((s) => s.id === params.sheetId))
      throw redirect({
        to: '/project/$projectId/workspaces/$workspaceId/bids/comparison',
        params,
        replace: true,
      });
  },
  loader: ({ params }) => {
    getDefaultStore().set(lastSelectedSheetIdAtom(params), params.sheetId);
  },
  validateSearch: z.object({
    commentEntityId: z.string().optional(),
    commentId: z.string().optional(),
  }),
});

function RouteComponent() {
  const { projectId, workspaceId } = Route.useParams();
  const view = useProjectView();

  return (
    <div className="@container flex flex-col min-h-0 grow">
      <Header>
        <HeaderBackButton
          to="/project/$projectId/workspaces/$workspaceId/bids"
          params={{ projectId, workspaceId }}
        />
        <BidsBreadcrumbs>
          <BreadcrumbPage>
            <Icon icon={ArrowDataTransferHorizontalIcon} />
            {t({
              en: view === 'client' ? 'Compare submissions' : 'Compare bids',
              nb: view === 'client' ? 'Sammenlign innleveringer' : 'Sammenlign tilbud',
            })}
          </BreadcrumbPage>
        </BidsBreadcrumbs>
        <HeaderChatButton />
      </Header>
      <BidComparisonSheetPage />
    </div>
  );
}
